module.exports = __webpack_public_path__ + "static/media/phplogo.7d92e04d.png";